import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const Register = () => {
  const nav = useNavigate();
  const [form, setForm] = useState({ username: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      const res = await fetch('https://api.laviopaperie.com/api/auth/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Register gagal');
      alert('Register berhasil, silakan login.');
      nav('/login');
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="camera-results" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <form onSubmit={onSubmit} style={{ background: '#fff', padding: 24, borderRadius: 12, width: 360 }}>
        <h2>Register</h2>
        {err && <div style={{ color: '#dc3545', marginBottom: 8 }}>{err}</div>}
        <div style={{ marginBottom: 12 }}>
          <label>Username</label>
          <input name="username" value={form.username} onChange={onChange} required className="start-button" style={{ width: '100%', padding: 10 }} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>Email</label>
          <input type="email" name="email" value={form.email} onChange={onChange} required className="start-button" style={{ width: '100%', padding: 10 }} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>Password</label>
          <input type="password" name="password" value={form.password} onChange={onChange} required minLength={6} className="start-button" style={{ width: '100%', padding: 10 }} />
        </div>
        <button type="submit" className="start-button" disabled={loading} style={{ width: '100%' }}>
          {loading ? 'Memproses...' : 'Daftar'}
        </button>
        <div style={{ marginTop: 12, textAlign: 'center' }}>
          Sudah punya akun? <Link to="/login">Login</Link>
        </div>
      </form>
    </div>
  );
};

export default Register;
